import script from "./PuestoView.vue?vue&type=script&setup=true&lang=js"
export * from "./PuestoView.vue?vue&type=script&setup=true&lang=js"

import "./PuestoView.vue?vue&type=style&index=0&id=14401382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14401382"]])

export default __exports__